"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Regex = void 0;
var Regex;
(function (Regex) {
    var cache = {};
    function from(pattern, flags) {
        var key = pattern.toString() + flags;
        if (cache.hasOwnProperty(key)) {
            return cache[key];
        }
        return new RegExp(pattern, flags);
    }
    Regex.from = from;
    Regex.Full = {
        Phone: new RegExp('^1[0-9]{10}$'),
        RobotPhone: new RegExp("^666[0-9]{8}$"),
        SandanPhone: new RegExp('^1[0-9]{10}$|^666[0-9]{8}$'),
        Integer: new RegExp("^-?\\d+$"),
        Float: new RegExp("^-?[1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*$|^-?[1-9]\\d*$"),
        Chinese: new RegExp("^[\u4e00-\u9fa5]$"),
        // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
        IdCard: new RegExp("^(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X)$"),
        QQ: new RegExp("^[1-9][0-9]{4,}$"),
        Url: /^[a-zA-z]+:\/\/[^\s\u4e00-\u9fa5]*$|^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+((com|net|edu|org|top|xyz|pub|name|red|info|biz|pro|museum|coop|aero|mobi|travel|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cq|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|es|et|fi|fj|fk|fm|fo|fr|ga|gd|ge|gf|gh|gi|gl|gm|gn|gp|gr|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|mg|mh|ml|mm|mn|mo|mp|mq|mr|ms|mt|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tl|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|za|zm|zw)\.?)(\/[^\s]*)*$/,
        Key: /^[a-z][a-z_0-9]{1,26}$/ // 键
    };
    // 不完整的匹配
    Regex.NotFull = {
        Phone: new RegExp('1[0-9]{10}'),
        RobotPhone: new RegExp("666[0-9]{8}"),
        SandanPhone: new RegExp('1[0-9]{10}|666[0-9]{8}'),
        Integer: new RegExp("-?\\d+"),
        Float: new RegExp("-?[1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*|-?[1-9]\\d*"),
        Chinese: new RegExp("[\u4e00-\u9fa5]"),
        IdCard: new RegExp("(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X)"),
        QQ: new RegExp("[1-9][0-9]{4,}"),
        Url: /[a-zA-z]+:\/\/[^\s\u4e00-\u9fa5]*|([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+((com|net|edu|org|top|xyz|pub|name|red|info|biz|pro|museum|coop|aero|mobi|travel|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cq|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|es|et|fi|fj|fk|fm|fo|fr|ga|gd|ge|gf|gh|gi|gl|gm|gn|gp|gr|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|mg|mh|ml|mm|mn|mo|mp|mq|mr|ms|mt|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tl|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|za|zm|zw)\.?)(\/[^\s]*)*/g,
        Key: /[a-z][a-z_0-9]{1,26}/ // 键
    };
    var SidPattern = /^[a-zA-Z1-9][a-zA-Z0-9_]{4,17}$/; // 散弹号
    Regex.SidRule = "字母或非0数字开头，只能包含字母、数字、下划线，长度在5~18之间，且不能是手机号"; // 散弹号规范
    function isSid(sid) {
        return SidPattern.test(sid) && !Regex.Full.SandanPhone.test(sid);
    }
    Regex.isSid = isSid;
    Regex.KeyRule = "只能包含小写英文字母、数字和下划线，不超过26个字母，不少于2个字母，首个字符不能是数字和下划线";
    function isKey(key) {
        return Regex.Full.Key.test(key);
    }
    Regex.isKey = isKey;
    //
    // static Phone = new RegExp('^1[0-9]{10}$')
    //
    // static RobotPhone = new RegExp("^666[0-9]{8}$")
    // static SandanPhone = new RegExp('^1[0-9]{10}$|^666[0-9]{8}$')
    // static Integer = new RegExp("^-?[1-9]\\d*$")
    // static Float = new RegExp("^-?[1-9]\\d*\\.\\d*|0\\.\\d*[1-9]\\d*$|^-?[1-9]\\d*$") // 浮点数也包括整数
    // static Chinese = new RegExp("^[\u4e00-\u9fa5]$")
    // static IdCard = new RegExp("^(\\d{6})(\\d{4})(\\d{2})(\\d{2})(\\d{3})([0-9]|X)$")
    // static QQ = new RegExp("^[1-9][0-9]{4,}$")
    // // 链接
    // static Url = /[a-zA-z]+:\/\/[^\s\u4e00-\u9fa5]*|([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+((com|net|edu|org|top|xyz|pub|name|red|info|biz|pro|museum|coop|aero|mobi|travel|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cq|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|es|et|fi|fj|fk|fm|fo|fr|ga|gd|ge|gf|gh|gi|gl|gm|gn|gp|gr|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|mg|mh|ml|mm|mn|mo|mp|mq|mr|ms|mt|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sk|sl|sm|sn|so|sr|ss|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tl|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|za|zm|zw)\.?)(\/[^\s]*)*/g;
    //
    //
})(Regex || (Regex = {}));
exports.Regex = Regex;
var Text;
(function (Text) {
    // converts a string to CamelCase.
    function camelCase(payload, uppers) {
        if (!payload) {
            return '';
        }
        var name = snakeCase(payload);
        uppers = uppers || [];
        var upper_set = new Set(['qq']); // 这里面的字符串都要大写
        for (var _i = 0, uppers_1 = uppers; _i < uppers_1.length; _i++) {
            var upper_item = uppers_1[_i];
            upper_set.add(upper_item);
        }
        name = name.replace(/[\s\-\/]/g, '_');
        // 空格、中划线、下划线需要做分割
        var lower_name = name.toLowerCase();
        var sp = lower_name.split('_').map(function (part) {
            if (upper_set.has(part)) {
                return part.toUpperCase();
            }
            return part.charAt(0).toUpperCase() + part.slice(1);
        });
        return sp.join('');
    }
    Text.camelCase = camelCase;
    function isUpper(value) {
        return value.toUpperCase() === value;
    }
    Text.isUpper = isUpper;
    function isLower(value) {
        return value.toLowerCase() === value;
    }
    Text.isLower = isLower;
    // converts a string to camelLowerCase.
    function camelLowerCase(payload, uppers) {
        var name = camelCase(payload, uppers);
        var index = 0;
        while (index < name.length - 1) {
            var next_char = name.charAt(index + 1);
            if (isUpper(next_char)) {
                index += 1;
            }
            else {
                break;
            }
        }
        if (name.length > 0) {
            name = name[0].toLowerCase() + name.slice(1);
        }
        return name.slice(0, index + 1).toLowerCase() + name.slice(index + 1);
    }
    Text.camelLowerCase = camelLowerCase;
    // converts a string to snake_case.
    function snakeCase(payload) {
        if (!payload) {
            return '';
        }
        var name;
        if (Array.isArray(payload)) {
            name = payload.join(' ');
        }
        else {
            name = payload || '';
        }
        var sp = [];
        var index = -1;
        for (var i = 0; i < name.length; i++) {
            var ch = name[i];
            if (/[A-Z\s_\-0-9\/]/.test(ch) || i === 0) {
                // 是大写字母 空格 下划线 字符串 数字，需要分隔开来
                if (/[\s_\-\/]/.test(ch)) {
                    ch = '';
                }
                if (index >= 0 && /[A-Z]/.test(name[i - 1]) && /[A-Z]/.test(name[i]) && (!name[i + 1] || /[A-Z]/.test(name[i + 1]))) {
                    // 前后连起来的两个大写字符要组合在一起（后面的字符必须是大写字符）
                    sp[index] += ch.toLowerCase();
                }
                else {
                    sp.push(ch.toLowerCase());
                    index += 1;
                }
            }
            else {
                sp[index] += ch.toLowerCase();
            }
        }
        return sp.filter(function (x) { return !!x; }).join('_');
    }
    Text.snakeCase = snakeCase;
    // converts a string to SNAKE_CASE_SCREAMING.
    function snakeScreamingCase(name) {
        return snakeCase(name).toUpperCase();
    }
    Text.snakeScreamingCase = snakeScreamingCase;
    // converts a string to kebab-case
    function kebabCase(name) {
        return snakeCase(name).replace(/_/g, "-");
    }
    Text.kebabCase = kebabCase;
    function kebabScreamingCase(name) {
        return kebabCase(name).toUpperCase();
    }
    Text.kebabScreamingCase = kebabScreamingCase;
    // converts a string to snake.case.delimited.
    function delimitedCase(name) {
        return snakeCase(name).replace(/_/g, ".");
    }
    Text.delimitedCase = delimitedCase;
    // converts a string to DELIMITED.SCREAMING.CASE
    function delimitedScreamingCase(name) {
        return delimitedCase(name).toUpperCase();
    }
    Text.delimitedScreamingCase = delimitedScreamingCase;
    function brief(content, length) {
        if (length === void 0) { length = 10; }
        content = content || '';
        length = length || 10;
        var brief = content.slice(0, length);
        if (content.length > length) {
            brief += '...';
        }
        return brief;
    }
    Text.brief = brief;
})(Text || (Text = {}));
exports.Text = Text;
//# sourceMappingURL=text.js.map